import React from 'react';

import '../styles/temp.css';

import logo from '../assets/logo.png'; // Import the logo image

/**
 *
 */
const Header = () => {
  return (
    <header>
      <div className="header-container">
        {/* Left Side: Logo and Text */}
        <a href="/" className="header-left">
          {/* Replace the logo placeholder with the actual image */}
          <img src={logo} alt="Nura Logo" className="logo" />
        </a>

        {/* Right Side: Location and Login */}
        <div className="header-right">{/* Location */}</div>
      </div>
    </header>
  );
};

export default Header;
